import React, { useEffect, useState } from "react";
import CadastroUsuarios from "./CadastroUsuarios";
import Menu from "./Menu";
import ico from "../assets/logoSvgBranco.png";

import "./Home.css";

export default function Home({ onLogout }) {
  const [aba, setAba] = useState(localStorage.getItem("abaHome") || "inicio");
  const [logs, setLogs] = useState([]);

  useEffect(() => {
    localStorage.setItem("abaHome", aba);
  }, [aba]);

  useEffect(() => {
    if (aba === "inicio") {
      const interval = setInterval(() => {
        const novas = [
          "Robô de Faturamento executado com sucesso ✅",
          "Robô de Email disparou notificações 📤",
          "Robô de Cadastro validou novos registros 🧾",
          "Robô de ERP finalizou integração 🔄",
        ];
        const log = novas[Math.floor(Math.random() * novas.length)];
        setLogs((prev) => [
          ...prev.slice(-8),
          `[${new Date().toLocaleTimeString()}] ${log}`,
        ]);
      }, 3000);
      return () => clearInterval(interval);
    }
  }, [aba]);

  return (
    <div className="home-container">
      <header>
        <div style={{display:"flex",flexDirection:"row", alignItems:"center", gap:"15px"}}>
          <img src={ico} style={{ width: "80px", height: "80px" }} />
          <h2> Portal RPA - Demonstrativo</h2>
        </div>

        <Menu onNavigate={setAba} onLogout={onLogout} /> {/* menu à direita */}
      </header>

      <main>
        {aba === "inicio" && (
          <>
            <section className="cards">
              <div className="card">
                <h3>Robôs Ativos</h3>
                <p>5</p>
              </div>
              <div className="card">
                <h3>Processos Hoje</h3>
                <p>24</p>
              </div>
              <div className="card">
                <h3>Tempo Economizado</h3>
                <p>3h 25min</p>
              </div>
            </section>

            <section className="logs">
              <h3>Logs de Execução</h3>
              <div className="log-box">
                {logs.map((l, i) => (
                  <p key={i}>{l}</p>
                ))}
              </div>
            </section>
          </>
        )}

        {aba === "cadastros" && <CadastroUsuarios />}
      </main>
    </div>
  );
}
